<template>
    <v-layout>
        <v-dialog v-model="sim.dialog" persistent scrollable width="30%">
            <v-card :loading="sim.loading">
                <template slot="progress">
                    <v-progress-linear color="amber darken-2" indeterminate></v-progress-linear>
                </template>
                <v-toolbar color="primary">
                    <v-toolbar-title style="color: white">{{$t('json.simfiles')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn dark :disabled="disabled" icon @click="refresh"><v-icon>mdi-cloud-refresh</v-icon></v-btn>
                </v-toolbar>
                <v-card-text style="max-height: 500px;">
                    <v-list two-line :disabled="disabled">
                        <v-list-item-group v-model="selectedIndex" multiple active-class="blue--text">
                            <template v-for="(project, index) in sim.SimProjects">
                                <v-list-item :key="project.ProjectName">
                                    <template v-slot:default="{ active }">
                                    <v-list-item-content>
                                        <v-list-item-title v-text="project.ProjectName"></v-list-item-title>
                                        <v-list-item-subtitle v-text="$t('json.simfiles_total') + ': ' + projectFilesLength(project)"></v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-icon v-if="!active" color="grey lighten-1">mdi-check-circle-outline</v-icon>
                                        <v-icon v-else color="blue darken-3">mdi-check-circle</v-icon>
                                    </v-list-item-action>
                                    </template>
                                </v-list-item>
                                <v-divider v-if="index < sim.SimProjects.length - 1" :key="index"></v-divider>
                            </template>
                        </v-list-item-group>
                    </v-list>
                </v-card-text>
                <v-card-text v-show="extensionError !== ''">
                  {{ extensionError }}
                  <v-checkbox v-model="markAsDownload" :label="$t('json.extension_notallowed_markd')"></v-checkbox>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn text @click="sim.dialog = false">{{$t('json.simfiles_close')}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="selectedIndex.length === 0 || disabled" color="primary" text @click="download">{{$t('json.simfiles_down')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
export default {
  name: 'SimFiles',
  props: ['sim', 'ws', 'disabled', 'batchTypes'],
  data () {
    return {
      selectedIndex: [],
      extensionError: '',
      markAsDownload: false
    }
  },
  methods: {
    projectFilesLength (project) {
      const filter = project.Files.filter(f => f.FileName.indexOf('batchProperties') !== 0)
      return filter.length
    },
    async refresh () {
      this.sim.loading = true
      this.$emit('refresh')
    },
    async download () {
      this.sim.loading = true
      // MarkIllegalExtensionAsDownloaded
      for (let a = 0; a < this.sim.SimProjects.length; ++a) {
        this.sim.SimProjects[a].MarkIllegalExtensionAsDownloaded = this.markAsDownload
      }
      this.$emit('download')
    },
    isExtnesionAllowed () {
      for (let a = 0; a < this.sim.SimProjects.length; ++a) {
        for (let i = 0; i < this.sim.SimProjects[a].Files.length; ++i) {
          const file = this.sim.SimProjects[a].Files[i]
          const ext = file.FileName.split('.').pop()
          const index = this.batchTypes.General.AllowedExtensions.indexOf(ext.toLowerCase())
          if (index < 0) {
            this.extensionError += (this.extensionError === '') ? this.$i18n.t('json.extension_notallowed') + ': ' : file.FileName + ', '
          }
        }
      }
    }
  },
  watch: {
    'sim.SimProjects': function (newVal) {
      this.extensionError = ''
      this.selectedIndex = []
    },
    selectedIndex: function (newVal) {
      this.extensionError = ''
      this.sim.SimProjects.forEach((pr) => { pr.Selected = false })
      newVal.forEach(i => {
        const pr = this.sim.SimProjects[i]
        pr.Selected = true
        this.isExtnesionAllowed()
      })
    }
  }
}
</script>
